import { z } from 'zod';

const Meta = z.object({
  current_page: z.number(),
  from: z.number().nullable(),
  last_page: z.number(),
  links: z.array(z.object({
    active: z.boolean(),
    label: z.string().nullable(),
    url: z.string().url().nullable(),
  })),
  path: z.string(),
  per_page: z.coerce.number(),
  to: z.number().nullable(),
  total: z.number(),
});

export default Meta;
